<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      {{ 'PAGES.OVERVIEW.FLUSH_CACHE_MODAL.TITLE' | translate }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="card-regular">
    <p>{{ 'PAGES.OVERVIEW.FLUSH_CACHE_MODAL.SUBTITLE' | translate }}</p>
  </mat-card-content>
  <mat-card-actions>
    <button mat-stroked-button id="force-cache-label" [disabled]="loading" (click)="showDialog()">
      {{ 'PAGES.OVERVIEW.FLUSH_CACHE_MODAL.BUTTONS.FLUSH_CACHE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
